import React from "react";
import { VALIDATION } from "../constants";

/**
 * Customer Information Component
 * Form for entering customer details including name, phone, address, and order type
 *
 * @param {Object} props
 * @param {Object} props.customer - Customer data object
 * @param {string} props.customer.name - Customer name
 * @param {string} props.customer.phone - Customer phone (max 10 digits)
 * @param {string} props.customer.address - Customer address
 * @param {string} props.customer.orderType - Order type ("dinein" or "takeaway")
 * @param {Function} props.setCustomer - Function to update customer state
 */
const CustomerInfo = ({ customer, setCustomer }) => {
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {/* Customer Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Customer Name
          </label>
          <input
            type="text"
            value={customer.name}
            onChange={(e) => setCustomer({ ...customer, name: e.target.value })}
            className="w-full px-3 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
            placeholder="Enter customer name"
          />
        </div>

        {/* Phone Number */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Phone Number
          </label>
          <input
            type="tel"
            value={customer.phone}
            onChange={(e) => {
              const value = e.target.value;
              if (
                /^\d*$/.test(value) &&
                value.length <= VALIDATION.MAX_PHONE_LENGTH
              ) {
                setCustomer({ ...customer, phone: value });
              }
            }}
            className="w-full px-3 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
            placeholder="Enter phone number"
            maxLength={VALIDATION.MAX_PHONE_LENGTH}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Order Type */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Order Type
          </label>
          <div className="flex gap-4">
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                value="dinein"
                checked={customer.orderType === "dinein"}
                onChange={(e) =>
                  setCustomer({ ...customer, orderType: e.target.value })
                }
                className="w-4 h-4 text-blue-600 focus:ring-blue-500"
              />
              <span className="ml-2 text-sm text-gray-700">Dine-In</span>
            </label>
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                value="takeaway"
                checked={customer.orderType === "takeaway"}
                onChange={(e) =>
                  setCustomer({ ...customer, orderType: e.target.value })
                }
                className="w-4 h-4 text-blue-600 focus:ring-blue-500"
              />
              <span className="ml-2 text-sm text-gray-700">Takeaway</span>
            </label>
          </div>
        </div>

        {/* Address */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Address
          </label>
          <textarea
            value={customer.address}
            onChange={(e) =>
              setCustomer({ ...customer, address: e.target.value })
            }
            rows={3}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
            placeholder="Enter customer address"
          />
        </div>
      </div>
    </div>
  );
};

export default CustomerInfo;
